export default {"src":"/_next/static/media/redact-predictive-modeling-icon.71126db6.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};